// extracted by mini-css-extract-plugin
export default {"badgeWrapper":"sm-z","badgeLink":"tm-z","category":"um-z"};